package com.vizio.redwolf.utils

data class HomeSetupEnvironmentConfig(val environmentGroup: EnvironmentGroup, val dmsJwt: String, val eCommApiKey: String, val dmsApiKey: String, val dmsV2ApiKey: String)


